import { FC } from 'react';
import { State } from 'redux/initialState';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { Partner } from 'types';
import { formatCurrencyDecimals } from 'utils/formats';

import { useOperationDetailsPage } from '../../context/OperationDetailsPageContext';
import { useGetContributionDataForPartner } from '../../hooks/useGetContributionDataForPartner';

type ContributionOperationDataRowProps = {
  index: number;
  partner: Partner;
};

const ContributionOperationTableRow: FC<ContributionOperationDataRowProps> = ({
  index,
  partner,
}) => {
  const actualSociety = useSelector(
    (state: State) => state.society.actualSociety
  );
  const { data } = useOperationDetailsPage();

  const { _id: partnerId, name: partnerName } = partner;

  const { data: contributionData } = useGetContributionDataForPartner({
    contributionOperation: data.operation,
    partner,
  });

  return (
    <>
      <td
        className="text-left vertical-align-middle pl-2 pl-md-2"
        key={`partner-name-${index}`}
      >
        <Link
          className="text-primary"
          to={`/detalle-socio/${actualSociety?._id}/${partnerId}`}
        >
          {partnerName}
        </Link>
      </td>

      <td
        className="text-right vertical-align-middle"
        key={`partner-nd-${index}`}
      >
        {(contributionData.ndPercentage || 0).toFixed(2)}%
      </td>

      <td
        className="text-right vertical-align-middle pr-2 pr-md-3"
        key={`partner-percibe-${index}`}
      >
        {formatCurrencyDecimals(contributionData.amount || 0)}
      </td>
    </>
  );
};
export default ContributionOperationTableRow;
